import { SystemUser } from '../types'
import { SystemUsersHttp } from '../http.ts'

const PREFIX = '/system-users'
const headers = {
  'Content-type': 'application/json'
}

export const systemUsersHealthCheck = () => {
  return SystemUsersHttp.get(`${PREFIX}/health-check`, {
    headers
  })
}

/** Pay SystemUser for the authenticated caller (SSO or legacy token). */
export const getCurrentSystemUserSession = () => {
  return SystemUsersHttp.get<SystemUser>(`${PREFIX}/current-session`, {
    headers
  })
}

export const updateSystemUserData = (payload: SystemUser | Partial<SystemUser>, systemUserId: string, accessToken: string) => {
  delete payload._id
  delete payload.selected
  delete payload.createdAt
  delete payload.username

  return SystemUsersHttp.put(
    `${PREFIX}/update-system-user/${systemUserId}`,
    { ...payload },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const deleteSystemUserData = (systemUserId: string, accessToken: string) => {
  return SystemUsersHttp.put(
    `${PREFIX}/delete-system-user/${systemUserId}`,
    {},
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const updateSystemUserPassword = (payload: object, accessToken: string) => {
  return SystemUsersHttp.put(
    `${PREFIX}/update-system-user-password`,
    { ...payload },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const getCurrentSystemUsers = (systemUserId: string, accessToken: string) => {
  return SystemUsersHttp.get(`${PREFIX}/system-users-data/${systemUserId}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getSystemUserDataById = (systemUserId: string, accessToken: string) => {
  return SystemUsersHttp.get(`${PREFIX}/system-user-data/${systemUserId}`, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const resendActivationEmail = (payload: object, accessToken: string) => {
  return SystemUsersHttp.post(`${PREFIX}/resend-activation-email`, payload, {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const createSystemUser = (systemUserData: SystemUser, accessToken: string) => {
  return SystemUsersHttp.post(
    `${PREFIX}/create`,
    { ...systemUserData },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const assignSystemUser = (payload: object, accessToken: string) => {
  return SystemUsersHttp.post(
    `${PREFIX}/assign-system-user`,
    { ...payload },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}

export const updateClientAssignedBalance = (clientId: string, newBalanceToSet: number, accessToken: string) => {
  return SystemUsersHttp.put(
    `${PREFIX}/update-client-assigned-balance/${clientId}`,
    { newBalanceToSet },
    {
      headers: {
        ...headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  )
}
